// Notizfeld zum Anruf oben im Verlauf der Lead-Seite . Name, Status und Dauer stehen NICHT mehr hier,
// sondern in der Anrufleiste oben (einheitlich für jeden Anruf).
// Steht ab dem Wählen da, bleibt nach dem Auflegen stehen (der Lead bleibt offen, bis man „Nächster Anruf“ klickt)
// und nimmt die Notiz zum Gespräch auf, während und nach dem Anruf (wird automatisch gespeichert). Kein Pflichtformular.
// Einbau: <AnrufKarte leadId={…} /> über dem Feed (pages/Lead.tsx); anrufKarteAktivitaetId() sagt, welche Aktivität
// des Feeds die Karte schon darstellt (damit der Anruf dort nicht doppelt steht).
// 19.10.2026 (Simon): Sobald gewählt wird, steht die Karte offen da und das Notizfeld hat den Fokus (Tippen geht sofort),
// auch direkt nach „Nächster Anruf“. Den Fokus nimmt es nur, wenn man nicht gerade in einem anderen Feld schreibt.
import { useEffect, useRef } from "react";
import { useTelefonie } from "./TelefonieProvider";
import "./telefonie.css";

const ERGEBNISSE: [string, string][] = [
  ["answered", "Gespräch"],
  ["vm-answer", "Mailbox, ohne Nachricht"],
  ["vm-left", "Mailbox, Nachricht hinterlassen"],
];

/** ID der Anruf-Aktivität im Feed, die diese Karte ersetzt (null, solange es keine gibt). */
export function useAnrufKarteAktivitaetId(leadId: string): string | null {
  const t = useTelefonie();
  return t.nacharbeit?.leadId === leadId ? (t.nacharbeit.call.activity_id ?? null) : null;
}

export function AnrufKarte({ leadId }: { leadId: string }) {
  const t = useTelefonie();
  const a = t.aktiverAnruf?.leadId === leadId ? t.aktiverAnruf : null;
  const n = t.nacharbeit?.leadId === leadId ? t.nacharbeit : null;
  const feld = useRef<HTMLTextAreaElement>(null);

  // Beim Wählen (und bei jedem neuen Anruf im Power Dialer) das Notizfeld öffnen und fokussieren
  const aktiv = !!a;
  useEffect(() => {
    if (!aktiv) return;
    const t0 = window.setTimeout(() => {
      const el = feld.current;
      if (!el || document.activeElement === el) return;
      const jetzt = document.activeElement as HTMLElement | null;
      const schreibtWoanders =
        !!jetzt && jetzt !== document.body && (jetzt.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(jetzt.tagName));
      if (schreibtWoanders) return;
      el.focus({ preventScroll: true });
      el.scrollIntoView({ block: "nearest" });
    }, 0);
    return () => window.clearTimeout(t0);
  }, [aktiv, leadId]);

  // Textfeld wächst mit dem Inhalt
  useEffect(() => {
    const el = feld.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = `${Math.min(240, el.scrollHeight)}px`;
  }, [t.notiz, a?.callId, n?.call.id]);

  if (!a && !n) return null;
  const c = n?.call;
  const angenommen = !!c?.answered_at;

  return (
    <section className={`tel-akarte${a ? " tel-akarte--aktiv" : ""}`} aria-label="Anruf" data-anrufkarte={a ? "aktiv" : "nacharbeit"}>
      <div className="tel-akarte__karte">
        <div className="tel-akarte__notiz">
          <textarea
            ref={feld}
            className="tel-akarte__feld"
            rows={a ? 3 : 1}
            placeholder={a ? "Notiz zum Anruf (wird automatisch gespeichert) …" : "Notiz hinzufügen …"}
            aria-label="Notiz zum Anruf"
            value={t.notiz}
            onChange={(e) => t.setNotiz(e.target.value)}
          />
        </div>
        {n && (
          <footer className="tel-akarte__fuss">
            {angenommen ? (
              <label className="tel-akarte__ergebnis">
                <span>Ergebnis</span>
                <select className="eingabe" value={c?.disposition && ERGEBNISSE.some(([w]) => w === c.disposition) ? c.disposition : "answered"} onChange={(e) => void t.ergebnisSetzen(e.target.value)}>
                  {ERGEBNISSE.map(([w, l]) => (
                    <option key={w} value={w}>
                      {l}
                    </option>
                  ))}
                </select>
              </label>
            ) : null}
            {!angenommen && c?.disposition === "error" ? <span className="tel-akarte__stand">Anruf kam nicht zustande</span> : null}
            <span className="tel-akarte__stand tel-akarte__stand--speichern">Notiz wird automatisch gespeichert</span>
          </footer>
        )}
      </div>
    </section>
  );
}
